<template>
  <v-container
    id="edit-agency"
    fluid
    tag="section"
  >
    <v-card
      class="mx-auto pa-5 mt-0"
      outlined
    >
      <div class="mb-5">
        <h3>CHI TIẾT MÃ KÍCH HOẠT: {{ activeCode.activeCode }}</h3>
      </div>
      <div>
        <v-simple-table class="table-layout border-table">
          <template v-slot:default>
            <thead style="background: #5D5FEF;" class="font-weight-bold">
              <tr>
                <th style="min-width: 30px">ID</th>
                <th>Tên mã</th>
                <th>Trạng thái mã</th>
                <th>Kiểu mã</th>
                <th>Ngày kích hoạt</th>
                <th>Ngày tạo mã</th>
                <th>SĐT kích hoạt</th>
                <th>SĐT đại lý</th>
                <th>Tên đại lý</th>
                <th>Người tạo</th>
                <th>Số lượng môn</th>
              </tr>
            </thead>
            <tbody class="bg-hover" :key="activeCode.id">
              <tr>
                <td>{{ activeCode.id }}</td>
                <td>
                  <span class="active-code-code font-weight-bold">
                    {{ activeCode.activeCode }}
                  </span>
                </td>
                <td>
                  <span :class="activeCode.status == 'active' ? 'status-active-code in-used'
                    : activeCode.status == 'inactive' ? 'status-active-code not-in-used'
                    : 'status-active-code active-code-pending'">
                    {{ getStatusActiveCode(activeCode.status) }}
                  </span>
                </td>
                <td>{{ typeActiveCodeIdNameObj[activeCode.type] }}</td>
                <td>
                  {{_.get(activeCode, 'activationAt', '')}}
                </td>
                <td>{{_.get(activeCode, 'createdAt', '')}}</td>
                <td>{{_.get(activeCode, 'activationPhone', '')}}</td>
                <td>{{_.get(activeCode, 'agencyPhone', '')}}</td>
                <td>{{_.get(activeCode, 'agencyName', '')}}</td>
                <td>{{_.get(activeCode, 'staffName', '')}}</td>
                <td>{{_.get(activeCode, 'numberOfSubject', '')}}</td>
              </tr>
              </tbody>
          </template>
        </v-simple-table>
        <div class="mt-5">
          <div style="color: #2ab4c0">Kiểu mã: {{ typeActiveCodeIdNameObj[activeCode.type] }}</div>
          <div>Hạn sử dụng: {{ activeCode.expiredAt }}</div>
          <div>Số lượng môn: {{ activeCode.numberOfSubject }}</div>
          <div>Thời gian học: {{ activeCode.studyTime }}</div>
        </div>
        <div v-if="!activeCodeRelated.length">
          <div class="text-center notice-no-related aquamarine-bg">
            <h3>THÔNG BÁO</h3>
            <span>Chưa có lịch sử tạo mã thay thế</span>
          </div>
        </div>
        <div v-else class="mt-5">
          <h3>LỊCH SỬ TẠO MÃ THAY THẾ</h3>
          <v-simple-table class="table-layout border-table mt-2">
            <template v-slot:default>
              <thead style="background: #5D5FEF;" class="font-weight-bold">
              <tr>
                <th style="min-width: 30px">Mã bị thay thế</th>
                <th>Mã thay thế</th>
                <th>Ngày tạo mã</th>
                <th>Người tạo</th>
                <th>SL môn</th>
                <th>Lý do thay thế</th>
              </tr>
              </thead>
              <template v-for="activeCode in activeCodeRelated">
                <tbody class="bg-hover" :key="activeCode.id">
                <tr>
                  <td
                      @click="clickDetailActiveCode(activeCode.oldCodeId, activeCode)"
                      class="active-code-code font-weight-bold">
                    {{ _.get(activeCode, 'oldCode', '')}}
                  </td>
                  <td>
                    <span
                        class="active-code-code font-weight-bold"
                        @click="clickDetailActiveCode(activeCode.newCodeId, activeCode)">
                    {{ _.get(activeCode, 'newCode', '') }}
                  </span>
                  <td>
                    {{_.get(activeCode, 'createdAt', '')}}
                  </td>
                  <td>{{_.get(activeCode, 'staffName', '')}}</td>
                  <td>{{_.get(activeCode, 'numberOfSubject', '')}}</td>
                  <td>{{ listReason[activeCode.reasonCode] }}</td>
                </tr>
                </tbody>
              </template>
            </template>
          </v-simple-table>
        </div>
      </div>
    </v-card>
  </v-container>
</template>
<script>
import RepositoryFactory from '@/repositories/RepositoryFactory'
const AgencyRepository = RepositoryFactory.get('agency')

export default {
  name: 'ActiveCodeDetail',
  props: {

  },
  data () {
    return {
      activeCode: {

      },
      activeCodeRelated: [],
      statusActiveCodeList: [
        {
          name: 'Đã kích hoạt',
          code: 'active'
        },
        {
          name: 'Chưa kích hoạt',
          code: 'pending'
        },
        {
          name: 'Ngừng hoạt động',
          code: 'inactive'
        }
      ],
      typeActiveCodeIdNameObj: {
        1: 'Mã dùng một lần',
        2: 'Mã dùng nhiều lần'
      },
      listReason: {
        'CODE_INACTIVE': 'Mã không hoạt động',
        'CODE_FAIL': 'Kích hoạt nhầm mã',
        'REPLACE_AGENCY': 'Thay thế mã cho đại lý',
        'OTHER_REASON': 'Lý do khác'
      }
    }
  },
  computed: {

  },
  mounted () {

  },
  created() {
    this.getDetail();
    this.getActiveCodeRelated();
  },
  methods: {
    clickDetailActiveCode (id, activeCode) {
      let routeData = this.$router.resolve({
        name: 'ActiveCodeDetail',
        params: {
          id: id || 0
        },
        query: {
          activeCodeCustomerId: activeCode.activeCodeCustomerId || null
        }
      });
      window.open(routeData.href, '_blank')
    },
    async getDetail() {
      const params = {
        activeCodeCustomerId: this.$route.query.activeCodeCustomerId || null
      }
      this.appLoadingData(true);
      const response = await AgencyRepository.getDetailActive(this.$route.params.id, params)
      this.appLoadingData(false)
      if (response.success) {
        this.activeCode = _.get(response, 'data', {})
      }
    },
    async getActiveCodeRelated() {
      const body = {
        activeCodeCustomerId: this.$route.query.activeCodeCustomerId || null
      }
      this.appLoadingData(true);
      const response = await AgencyRepository.getActiveCodeRelated(this.$route.params.id, body)
      this.appLoadingData(false)
      if (response.success) {
        this.activeCodeRelated = _.get(response, 'data', [])
      }

    },
    getStatusActiveCode(statusCode) {
      let indexStatus = this.statusActiveCodeList.findIndex(item => item.code == statusCode);
      if (indexStatus > -1) {
        return this.statusActiveCodeList[indexStatus].name
      }
      return '';
    }
  }
}
</script>
<style lang="css" scoped>
    /deep/ tbody td {
      border-bottom: thin solid rgba(0, 0, 0, 0.12);
    }
    /deep/ .theme--light .v-data-table table thead tr th {
      color: #ffffff !important;
    }
    .status-active-code {
      padding: 5px 10px;
      font-weight: bold;
      border-radius: 12px;
      white-space: nowrap;
    }
    .in-used {
      border: 1px solid #59ac31;
      color: #59ac31;
      background-color: #f0f9eb;
    }
    .active-code-pending {
      border: 1px solid #ef4512;
      color: #ef4512;
      background-color: #f8e5d8;
    }
    .not-in-used {
      border: 1px solid #f51212;
      color: #f51212;
      background-color: #f8d2d2;
    }
    .active-code-code {
      cursor: pointer;
      color: #0d9aff;
    }
    .notice-no-related {
      width: 300px;
      margin: 0 auto;
      padding: 20px;
      color: #fff;
      border-radius: 12px;
      margin-bottom: 5px;
      background: #099753;
    }
    .table-layout tbody tr {
      height: 50px;
    }
</style>
